import {
	DropdownMenu,
	DropdownMenuTrigger,
	DropdownMenuContent,
	DropdownMenuLabel,
	DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { ListExportDropdown } from "@/types/list";
import { useExportTable } from "./useExportTable";
import { FC } from "react";
import { Download } from "lucide-react";

export const ExportDropdown = <TData,>(props: ListExportDropdown<TData>): ReturnType<FC> => {
	const { possibleExportAllData, format, rowCount, exportAll, setFormat, setExportAll, exportNow } =
		useExportTable(props);
	const { loading } = props;
	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant="default" size="sm" disabled={loading || false}>
					Export
					<Download className="mr-1 h-3 w-3" />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent className="w-64 p-2 space-y-2">
				<DropdownMenuLabel>Export</DropdownMenuLabel>
				<DropdownMenuSeparator />

				<RadioGroup value={format} onValueChange={val => setFormat(val as any)} className="space-y-1 px-2">
					{["csv", "excel", "json"].map(type => (
						<div key={type} className="flex items-center space-x-2">
							<RadioGroupItem value={type} id={type} />
							<label htmlFor={type} className="text-sm uppercase">
								{type}
							</label>
						</div>
					))}
				</RadioGroup>

				<DropdownMenuSeparator />

				{possibleExportAllData && (
					<div className="flex items-center space-x-2 px-2">
						<Checkbox
							id="exportAll"
							checked={exportAll}
							onCheckedChange={checked => setExportAll(!!checked)}
						/>
						<label htmlFor="exportAll" className="text-sm">
							Export all rows
						</label>
					</div>
				)}
				<div className="px-2 text-xs text-muted-foreground text-left">
					Exporting {rowCount} row{rowCount !== 1 ? "s" : ""}
				</div>
				<div className="px-2">
					<Button className="w-full mt-2" onClick={exportNow}>
						Export {format.toUpperCase()}
					</Button>
				</div>
			</DropdownMenuContent>
		</DropdownMenu>
	);
};
